import styled from '@emotion/styled';

export const TimelineMaintenanceBase = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${(p) => p.theme.color.grayDark3};
    width: 100%;
`;

export const ItemsContainer = styled.div`
    display: flex;
    min-width: 500px;
    justify-content: space-between;
`;
